import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatBuildTime } from "../lib/buildInfo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const { user } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (user) window.location.href = "/";
    if (location.state?.error) toast.error(location.state.error);
  }, [user, location.state]);

  const signIn = () => {
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const published = formatBuildTime();

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background grain">
      <div className="hidden lg:flex flex-col justify-between p-14 bg-primary text-primary-foreground relative z-10">
        <div className="flex items-center gap-3">
          <img src="/logo.png" alt="logo" className="w-12 h-12 rounded-full" />
          <span className="font-heading text-2xl font-semibold">Harmony Wellness Group</span>
        </div>
        <div className="space-y-6">
          <h1 className="font-heading text-4xl sm:text-5xl font-semibold leading-tight">A month of on-brand content, generated in minutes.</h1>
          <p className="text-primary-foreground/80 text-lg max-w-md">Crawl your brand, batch-generate weeks of posts, get client approval, and manage every conversation — in one calm workspace.</p>
        </div>
        <p className="text-sm text-primary-foreground/60">Social Media Manager · AI-powered · Brand-grounded</p>
      </div>
      <div className="flex items-center justify-center p-6 relative z-10">
        <div className="w-full max-w-md space-y-10 text-center">
          <div className="space-y-4">
            <img src="/logo.png" alt="logo" className="w-20 h-20 rounded-full mx-auto" />
            <div>
              <h2 className="font-heading text-2xl font-semibold">Harmony Wellness Group</h2>
              <p className="text-sm text-muted-foreground mt-1 uppercase tracking-[0.2em]">Social Media Manager</p>
              {published && (
                <p data-testid="login-build-timestamp" className="text-xs text-muted-foreground/70 mt-2">
                  Published {published}
                </p>
              )}
            </div>
          </div>
          <div className="space-y-4">
            <button data-testid="google-login-btn" onClick={signIn}
              className="w-full flex items-center justify-center gap-3 px-6 py-3.5 rounded-full bg-primary text-primary-foreground font-semibold text-sm hover:opacity-90 transition-opacity">
              <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
                <path fill="#EA4335" d="M12 5.04c1.62 0 3.06.56 4.2 1.64l3.12-3.12C17.44 1.8 14.94.75 12 .75 7.53.75 3.69 3.32 1.82 7.06l3.66 2.84C6.36 7.02 8.94 5.04 12 5.04z"/>
                <path fill="#4285F4" d="M23.25 12.27c0-.93-.08-1.6-.26-2.3H12v4.35h6.44c-.13 1.08-.83 2.7-2.39 3.79l3.57 2.77c2.14-1.97 3.63-4.88 3.63-8.61z"/>
                <path fill="#FBBC05" d="M5.49 14.1a7.03 7.03 0 0 1-.38-2.1c0-.73.13-1.44.36-2.1L1.82 7.06A11.22 11.22 0 0 0 .75 12c0 1.81.43 3.52 1.07 4.94l3.67-2.84z"/>
                <path fill="#34A853" d="M12 23.25c3.04 0 5.6-1 7.46-2.72l-3.57-2.77c-.95.66-2.23 1.13-3.89 1.13-3.06 0-5.64-1.98-6.51-4.79l-3.66 2.84c1.86 3.74 5.7 6.31 10.17 6.31z"/>
              </svg>
              Continue with Google
            </button>
            <p className="text-xs text-muted-foreground">Access is restricted to authorised team accounts.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
